import React from "react";
import { BsClockHistory, BsExclamationTriangleFill, BsPersonXFill, BsCashCoin } from "react-icons/bs";

const AlertsBanner = ({ alerts, loading }) => {
    if (loading || !alerts) return null;

    const items = [
        { key: "pendingSettlements", label: "Bookings awaiting settlement", icon: <BsCashCoin />, severity: "warning" },
        { key: "unassignedTasks", label: "Unassigned delivery/pickup tasks", icon: <BsExclamationTriangleFill />, severity: "warning" },
        { key: "overdueTasks", label: "Overdue tasks", icon: <BsClockHistory />, severity: "danger" },
        { key: "rejectedVerifications", label: "Customers with rejected KYC", icon: <BsPersonXFill />, severity: "danger" },
    ].filter((item) => Number(alerts[item.key] || 0) > 0);

    if (!items.length) return null;

    return (
        <div className="db-section db-alerts-row">
            {items.map((item) => (
                <div className={`db-alert-chip is-${item.severity}`} key={item.key}>
                    <span className="db-alert-icon">{item.icon}</span>
                    <div>
                        <div className="db-alert-count">{Number(alerts[item.key]).toLocaleString()}</div>
                        <div className="db-alert-label">{item.label}</div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AlertsBanner;
